module.exports = __webpack_public_path__ + "img/story048.464ad6b6.webp";